import * as Sentry from '@sentry/react';

import type { BackendTypes } from '@tf/api';
import { BackendClient } from '@tf/api';

import { getObjectUriByNodeId } from '@/core/api/legacy';
import type { ExtendedReviewContainer } from '@/core/types';
import type { AccountWithReviews } from '@/core/types/account';

export const getAccountQuery = async (accountId: number): Promise<AccountWithReviews> => {
	const api = BackendClient.getInstance();

	// * Get account meta
	const [profileId, meta] = await Promise.all([
		getObjectUriByNodeId(accountId),
		api.entityGet(accountId).then((res) => res.json() as Promise<AccountWithReviews['meta']>),
	]);

	// * Get reviews from account
	// TODO: This is a temporary solution, we need to implement batch review fetching
	const connections = meta.listConnections
		.filter((connection) => connection.isReview)
		.map((connection) =>
			connection.listFromEntities.map((entity) => ({
				graphLinkId: entity.graphLinkId,
				graphNodeId: entity.graphNodeId,
			}))
		)
		.flat();

	const reviews: ExtendedReviewContainer[] = await Promise.all(
		connections.map(async (connection) => {
			try {
				const res = await api.reviewGet(connection.graphLinkId);
				const review: BackendTypes.ReviewGetData = await res.json();
				return { ...review, ...connection };
			} catch (err) {
				Sentry.captureMessage('Failed to load review', {
					level: 'error',
					extra: {
						accountId,
						reviewGraphLinkId: connection.graphLinkId,
						httpStatus: err instanceof Response ? err.status : '',
					},
				});
				throw err;
			}
		})
	);

	return { profileId, meta, reviews };
};
